import { AirlineApplicableDeviationRequests, ApplicableDeviationRequest, TravelRequestData } from 'api/travel-request-detail';
import { DialogController } from 'aurelia-dialog';
import { EventAggregator, Subscription } from 'aurelia-event-aggregator';
import { autoinject, computedFrom } from 'aurelia-framework';
import { TransportSegment } from 'model/forms/trip-details';
import { HOME_ROUTE } from 'support/settings';
import { Router } from 'aurelia-router';
import { DeviationSettings, DeviationSettingsPrepopulatedFields } from 'model/forms/deviation-request';
import { DataTransferer } from 'support/shared_models/data-transferer';
import { DeviationDetailType, DeviationType, DeviationWorkflowType } from 'model/business-enums';
import { CorporateTraveler } from 'model/forms/travel-request';

@autoinject
export class ApplicableDeviationsDialog {
  private routerSubscription: Subscription;
  options: ApplicableDeviationsOptions;

  constructor(private dialogController: DialogController, private ea: EventAggregator, private router: Router, private transferer: DataTransferer) { }

  activate(options: ApplicableDeviationsOptions) {
    this.options = options;
  }

  attached() {
    this.routerSubscription = this.ea.subscribe('router:navigation:complete', () => this.dialogController.ok());
  }

  detached() {
    if (this.routerSubscription != null)
      this.routerSubscription.dispose();
  }

  showDeviationRequest(request: ApplicableDeviationRequest) {
    this.router.navigate(`#/${HOME_ROUTE}/deviationRequests/${request.id}`);
  }

  createDeviationRequest(transportSegment: TransportSegment) {
    this.transferer.set('INITIAL-DEVIATION-SETTINGS', {
      deviationType: DeviationType.SingleInstance,
      workflowType: DeviationWorkflowType.Aviation,
      detailType: DeviationDetailType.AirlineExtended,
      copyFromId: null,
      prepopulatedFields: {
        airline: transportSegment.airline,
        airlineCustomName: transportSegment.airline === null ? transportSegment.airlineName : null,
        validFrom: transportSegment.departureDate,
        validTo: transportSegment.departureDate,
        travelers: this.options.travelRequest.travelers.filter(x => x.kind === 'corporate-traveler').map(x => (x as CorporateTraveler).user)
      } as DeviationSettingsPrepopulatedFields
    } as DeviationSettings);
    this.router.navigate(`#/${HOME_ROUTE}/deviationRequests/new`);
  }

  @computedFrom('options.airlinesTransportSegments', 'options.airlinesApplicableDeviations')
  get airlinesWarnings() {
    return this.options.airlinesTransportSegments.map(transportSegment => {
      const airlineApplicableDeviations = this.options.airlinesApplicableDeviations.filter(x => (transportSegment.airline !== null && x.airlineId !== null && transportSegment.airline.id === x.airlineId) || (transportSegment.airlineName !== null && x.airlineCustomName !== null && transportSegment.airlineName === x.airlineCustomName));
      return {
        transportSegment: transportSegment,
        airlineStatusName: transportSegment.airline !== null ? transportSegment.airline.status.name : 'Non Approved',
        airlineApplicableDeviations: airlineApplicableDeviations !== null && airlineApplicableDeviations.length > 0 ? airlineApplicableDeviations[0].applicableDeviationRequest : []
      };
    });
  }

  ok() {
    this.dialogController.ok();
  }
}

export interface ApplicableDeviationsOptions {
  travelRequest: TravelRequestData;
  airlinesTransportSegments: TransportSegment[];
  airlinesApplicableDeviations: AirlineApplicableDeviationRequests[];
}
